/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import { TextInputProps } from 'ui/components/inputs/types'
import { Eye } from 'ui/svg/icons/Eye'
import { EyeSlash } from 'ui/svg/icons/EyeSlash'

type Props = {
  shouldHidePassword: boolean
  setShouldHidePassword: (shouldHidePassword: boolean) => void
  disabled?: boolean
}

type Output = NonNullable<TextInputProps['rightButton']> | undefined

export const RightButton = ({
  shouldHidePassword,
  setShouldHidePassword,
  disabled,
}: Props): Output => {
  if (disabled) return undefined

  const onPress = () => setShouldHidePassword(!shouldHidePassword)
  const icon = shouldHidePassword ? EyeSlash : Eye
  const accessibilityLabel = shouldHidePassword
    ? 'Afficher le mot de passe'
    : 'Cacher le mot de passe'

  return { icon, onPress, accessibilityLabel }
}
